import React from "react"
import ResetPasswordForm from "../../sections/ResetPasswordForm/ResetPasswordForm"
import "./ResetPassword.css"

function ResetPassword() {
  return (
    <main className='ResetPassword auth-page'>
      <ResetPasswordForm />
    </main>
  )
}

export default ResetPassword
